<template functional>
  <div>
    <template
      v-if="
        props.row[props['column']].activity_values[0] &&
        !isNaN(Number(props.row[props['column']].activity_values[0].price))
      "
    >
      <format :value="props.row[props['column']].activity_values[0].price" />
    </template>
    <iconwarning v-else />
  </div>
</template>
<script>
export default {
  functional: true,
  name: 'UnitPriceErrorFormatter',
};
</script>
